import { render, staticRenderFns } from "./BroadcastMessageBanner.vue?vue&type=template&id=1727c3d9&"
import script from "./BroadcastMessageBanner.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports